import React from 'react';

const FilterChips = ({ chips, onClearAll, showClearAll = true, className = '' }) => {
  if (chips.length === 0) {
    return null;
  }

  return (
    <div className={`filter-chips ${className}`.trim()}>
      {chips.map((chip, index) => (
        <div key={index} className="filter-chip">
          <span>{chip.label}</span>
          <button onClick={chip.onRemove} aria-label={`Remove ${chip.label} filter`}>
            ×
          </button>
        </div>
      ))}
      
      {showClearAll && chips.length > 0 && typeof onClearAll === 'function' && (
        <button className="clear-filters" onClick={onClearAll}>
          Clear All Filters
        </button>
      )}
    </div>
  );
};

export default FilterChips; 